export const hasToRedirectToPatientPlaylist = () => {
  const subdomain = window.location.hostname;

  const notInSubdomains = [
    "www.app.digidocteur.com",
    "app.digidocteur.com",
    "127.0.0.1",
    "staging.digidocteur.com",
    "app.staging.digidocteur.com",
    "www.app.staging.digidocteur.com",
    "local.digidocteur.com",
    "app.local.digidocteur.com",
    "www.app.local.digidocteur.com",
  ];

  return subdomain === "localhost" || notInSubdomains.indexOf(subdomain) < 0;
};



// WEBPACK FOOTER //
// ./src/pages/utils/auth/AuthTools.js